import { AnimatePresence } from "framer-motion";
import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useWebSocket } from "../context/WebSocketContext";
import {
    ActionButton,
    ButtonRow,
    Emojis,
    ModalBox,
    ModalOverlay,
} from "./styles/EndSessionModal";

const EndSessionModal = ({ show, onClose, onDownload, onSubmit }) => {
    const { socket, transData } = useWebSocket();
    const [selected, setSelected] = useState(null);
    // const [npsScore, setNpsScore] = useState(null);
    // const [fcrValue, setFcrValue] = useState(null);
    const [comment, setComment] = useState("");
    const [remainingTime, setRemainingTime] = useState(50 * 60);
    const [submitting, setSubmitting] = useState(false);
    const warnedRequiredRef = useRef(false);

    const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);
    const clientId = searchParams.get("clientId") || "";
    const channelConfigId = searchParams.get("channelConfigId") || "";

    const effectiveTransData = useMemo(() => {
        let td = { ...(transData || {}) };
        const p = td?.produto ?? searchParams.get("produto");
        const a = td?.area ?? searchParams.get("area");
        if (p) td.produto = p;
        if (a) td.area = a;
        return td;
    }, [transData, searchParams]);

    useEffect(() => {
        if (!show) return;
        if (!warnedRequiredRef.current && (!effectiveTransData?.produto || !effectiveTransData?.area)) {
            warnedRequiredRef.current = true;
            //toast.warn("⚠️ Campos obrigatórios ausentes no transData: produto/area.", { autoClose: 6000 });
        }
    }, [show, effectiveTransData?.produto, effectiveTransData?.area]);

    useEffect(() => {
        if (!show) return;

        const closeTimer = setTimeout(() => window.close(), 50 * 60 * 1000);
        const tick = setInterval(() => {
            setRemainingTime((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => {
            clearTimeout(closeTimer);
            clearInterval(tick);
        };
    }, [show]);

    const emojiOptions = [
        { emoji: "😍", label: "5 - Ótimo", value: "5" },
        { emoji: "😃", label: "4 - Gostei", value: "4" },
        { emoji: "😐", label: "3 - Regular", value: "3" },
        { emoji: "😟", label: "2 - Achei ruim", value: "2" },
        { emoji: "😠", label: "1 - Péssimo", value: "1" },
    ];

    const handleSubmit = () => {
        if (selected == null) {
            toast.warn("Por favor, selecione uma das carinhas antes de enviar.", { autoClose: 5000 });
            return;
        }

        //if (!effectiveTransData?.produto || !effectiveTransData?.area) {
        //    toast.warn("⚠️ produto/area não informados. O envio continuará, mas o backend pode recusar.", {
        //        autoClose: 6000,
        //    });
        //}

        setSubmitting(true);

        const payload = {
            evaluation: emojiOptions[selected].value,
            comment: comment || "-",
            channelConfigId,
            userId: clientId
            // ...(npsScore ? { npsScore } : {}),
            // ...(fcrValue ? { fcrValue } : {}),
        };

        onSubmit("chat_rating", payload);
        onClose();

        setTimeout(() => {
            window.close();
        }, 300);

        setTimeout(() => setSubmitting(false), 500);
    };

    const mm = Math.floor(remainingTime / 60);
    const ss = String(remainingTime % 60).padStart(2, "0");

    return (
        <AnimatePresence>
            {show && (
                <ModalOverlay>
                    <ModalBox
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                    >
                        <h3>Seu atendimento foi encerrado!</h3>
                        <p>Sua avaliação é muito importante para nós.</p>

                        <Emojis>
                            {emojiOptions.map((item, index) => (
                                <span
                                    key={index}
                                    title={item.label}
                                    onClick={() => setSelected(index)}
                                    style={{
                                        cursor: "pointer",
                                        fontSize: selected === index ? "42px" : "32px",
                                        transform: selected === index ? "scale(1.2)" : "scale(1)",
                                        transition: "transform 0.2s, font-size 0.2s",
                                        border: selected === index ? "2px solid #3c51e8" : "none",
                                        borderRadius: "12px",
                                        padding: "6px",
                                        backgroundColor: selected === index ? "#e0e7ff" : "transparent",
                                    }}
                                >
                                    {item.emoji}
                                </span>
                            ))}
                        </Emojis>

                        <div style={{ position: "relative", width: "100%" }}>
                            <textarea
                                placeholder="Escreva um comentário (opcional)"
                                value={comment}
                                onChange={(e) => {
                                    const text = e.target.value;
                                    if (text.length <= 1500) setComment(text);
                                }}
                                maxLength={1500}
                                style={{
                                    width: "100%",
                                    marginTop: "20px",
                                    padding: "10px",
                                    fontSize: "14px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    resize: "none",
                                    minHeight: "60px",
                                    paddingBottom: "26px",
                                }}
                            />
                            <p
                                style={{
                                    position: "absolute",
                                    bottom: "6px",
                                    right: "10px",
                                    fontSize: "12px",
                                    color: "#888",
                                    opacity: 0.6,
                                    margin: 0,
                                    pointerEvents: "none",
                                }}
                            >
                                {comment.length}/1000
                            </p>
                        </div>

                        <ButtonRow>
                            <ActionButton
                                onClick={() => {
                                    onClose();
                                    if (socket && socket.readyState === WebSocket.OPEN) {
                                        socket.close(1000, "Encerrado pelo usuário");
                                    }
                                    setTimeout(() => window.close(), 100);
                                }}
                            >
                                SAIR
                            </ActionButton>
                            <ActionButton onClick={onDownload}>BAIXAR HISTÓRICO</ActionButton>
                            <ActionButton onClick={handleSubmit} disabled={submitting}>
                                {submitting ? "ENVIANDO..." : "ENVIAR"}
                            </ActionButton>
                        </ButtonRow>

                        <p
                            style={{
                                marginTop: "16px",
                                fontSize: "12px",
                                color: "#888",
                                opacity: 0.6,
                            }}
                        >
                            Esta janela será fechada automaticamente em {mm}:{ss} minutos.
                        </p>
                    </ModalBox>
                </ModalOverlay>
            )}
        </AnimatePresence>
    );
};

export default EndSessionModal;
